module.exports = __webpack_public_path__ + "img/mobileResidentOffice1.5b24be0b.png";